export const NEW_CONTENT = 'NEW_CONTENT';
